import 'ui-theme/components/sections-navbar/js/sections-navbar';

const {sidebarSections} = UX;
const {init} = sidebarSections;
sidebarSections.vPort = 'screen-md';
sidebarSections.init = function () {
    init();
    const visualBtn = document.querySelector('.visual-abstract-btn');
    const actionContainer = document.querySelector('.actionsbar .actions-block-container');

    if (document.querySelector('.visual-abstract__figure') && visualBtn) {
        visualBtn.classList.add('visible');
        actionContainer.classList.add('has-visual-abstract-btn');
    }
};
